import React, { createContext, useState, useContext } from 'react';

const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {
  const [employeeMenuOpen, setEmployeeMenuOpen] = useState(false);

  return (
    <SidebarContext.Provider value={{ employeeMenuOpen, setEmployeeMenuOpen }}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => useContext(SidebarContext);
